var _path;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgCheckMark = function SvgCheckMark(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.24255 13.4204C6.51714 14.1458 5.3401 14.1458 4.61504 13.4204L0.544058 9.34932C-0.181353 8.62425 -0.181353 7.44718 0.544058 6.7221C1.26912 5.99668 2.44616 5.99668 3.17157 6.7221L5.59708 9.14731C5.78018 9.33007 6.07742 9.33007 6.26087 9.14731L12.8284 2.57961C13.5535 1.85418 14.7305 1.85418 15.4559 2.57961C15.8043 2.92797 16 3.40061 16 3.89322C16 4.38582 15.8043 4.85847 15.4559 5.20683L7.24255 13.4204Z",
    fill: "#FECF01"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgCheckMark);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "assets/icons/check-mark.svg";